/*----------------------------------
- FAQ ANSWER WITH OPTIONAL LINK
----------------------------------*/

import GlossaryText from '@/client/components/glossary/GlossaryText';

import type { FAQLink } from '@/client/catalogs/landing/faq';

type FaqAnswerItem = {
    answer: string;
    link?: FAQLink;
};

type FaqAnswerProps = {
    item: FaqAnswerItem;
    showLink?: boolean;
    /** Set by `/pricing`, so reading a policy page does not cost the visitor the plan card. */
    openInNewTab?: boolean;
};

const FaqAnswer = ({ item, showLink = true, openInNewTab = false }: FaqAnswerProps) => (
    <div class="mt-[14px]">
        {/* One answer is one section: a term explained in the answer above is explained again
            here, because a reader opening a single question never saw the other one. */}
        <p class="text-[14.5px] leading-[1.65] text-slate-600">
            <GlossaryText>{item.answer}</GlossaryText>
        </p>
        {showLink && item.link ? (
            <a
                href={item.link.href}
                {...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                class="mt-3 inline-flex rounded-sm text-[13.5px] font-semibold text-slate-800 underline decoration-slate-300 underline-offset-4 transition hover:decoration-slate-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400"
            >
                {item.link.label}
            </a>
        ) : null}
    </div>
);

export default FaqAnswer;
